import { DASH_SLASH } from 'consts/placeholders';

type ListWithDividerItem = {
  code: string;
  name: string;
};

type ListWithDividerProps = {
  list: ListWithDividerItem[];
  dataTestId?: string;
};

const ListWithDivider = ({ list, dataTestId = '' }: ListWithDividerProps): React.ReactElement => (
  <p
    className="flex flex-wrap divide-x space-x-1.5 items-center body-sm text-neutral-950-opacity-80"
    data-test-id={dataTestId}
  >
    {list.length
      ? list.map((item) => (
          <span key={item.code} className="block pl-1 mb-0.5">
            {item.name}
          </span>
        ))
      : DASH_SLASH}
  </p>
);

export default ListWithDivider;
